<template>
  <div class="time-component">
    <p class="title">time</p>
    <p>next eclipse: {{ _nextEclipseTime }}</p>
    <p>current time: {{ _timeNow }}</p>
    <p>elapsed time: {{ _elapsedTime }}</p>
  </div>
</template>

<script>
import { format } from 'date-fns';

export default {
  props: {
    nextEclipseDate: Date,
    nowDate: Date,
    elapsedTime: String,
  },
  computed: {
    _nextEclipseTime() {
      if (!this.$props.nextEclipseDate) {
        return 'calculating...';
      }

      return format(this.$props.nextEclipseDate, 'HH:mm:ss');
    },
    _timeNow() {
      if (!this.$props.nowDate) {
        return;
      }

      return format(this.$props.nowDate, 'HH:mm:ss');
    },
    _elapsedTime() {
      if (!this.$props.elapsedTime) {
        return '00:00:00';
      }

      return this.$props.elapsedTime;
    },
  },
};
</script>

<style lang="scss" scoped>
.time-component {
  width: 100%;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @include spLandscape {
    display: none;
  }

  p {
    margin-bottom: 13px;
    text-align: end;
    font-size: 10px;
    letter-spacing: 1px;
    color: #070751;

    @include sp {
      margin-bottom: 17px;
    }
  }
}

.title {
  font-weight: 500;
  margin-bottom: 15px;
}
</style>
